import { ContentChild, Directive } from "@angular/core";
import { LinkElementComponent } from "../link-element/link-element.component";

@Directive()
export abstract class WidgetWithLink {

    @ContentChild(LinkElementComponent) link: LinkElementComponent;
}